import APIS_CONSTANTS from "./ApiConstants";
import http from "./http";

class Services {
  getOrganization({ orgId, url }) {
    return http.get(APIS_CONSTANTS.organization, {
      params: { org_id: orgId, url },
      silentError: true,
    });
  }
  getChatSettings({ orgId, type, dashboardToken }) {
    return http.get(`${APIS_CONSTANTS.chatSettings}/${type}`, {
      params: { org_id: orgId },
      silentError: true,
      ...(dashboardToken && { headers: { Authorization: `Bearer ${dashboardToken}` } }),
    });
  }
  getTags(orgId) {
    return http.get(APIS_CONSTANTS.tags, {
      params: { org_id: orgId },
      silentError: true,
    });
  }
  getShops(orgId) {
    return http.get(APIS_CONSTANTS.shops, {
      params: { org_id: orgId },
      silentError: true,
    });
  }
  getActiveEmployees({ orgId, start }) {
    return http.get(APIS_CONSTANTS.listActiveEmployee, {
      params: { org_id: orgId, start },
    });
  }
  getAppConfig() {
    return http.get(APIS_CONSTANTS.getAppConfig, {
        params: { frontend_id: "chat_services_widget" },
    });
  }
  getProductsByIds(ids) {
    const serializedParams = `?${ids.map(id => `ids=${id}`).join('&')}`;
    return http.get(`${APIS_CONSTANTS.getProductsByIds}${serializedParams}`);
  }
  
  fetchAllMessages(chatId) {
    const url = `${APIS_CONSTANTS.getMessagesByChat}/${chatId}?size=1000000`;
    return http.get(url);
  }

  fetchMessages(chatId, { page = 0, size = 30 } = {}) {
    const url = `${APIS_CONSTANTS.getMessagesByChat}/${chatId}?page=${page}&size=${size}&sort=createdAt,desc`;
    return http.get(url);
  }

  // Group channels services
  getGroupChannels(token) {
    return http.get(APIS_CONSTANTS.getGroupChannels, {
      headers: {
        Token: token,
      },
    });
  }

  // public group channels for guest users
  getGroupChannelsForGuest(orgId) {
    return http.get(APIS_CONSTANTS.getGroupChannelsForGuests, {
      params: { orgId },
    });
  }

  getGroupMessages(groupId, token) {
    return http.get(`${APIS_CONSTANTS.getGroupMessages}/${groupId}`, {
      headers: {
        Token: token,
      },
    });
  }

  getGroupMessagesPaginated(groupId, token, { page = 0, size = 10 } = {}) {
    return http.get(`${APIS_CONSTANTS.getGroupMessages}/${groupId}`, {
      params: { page, size },
      headers: {
        Token: token,
      },
    });
  }

  joinGroup(groupId, token) {
    return http.post(`${APIS_CONSTANTS.joinGroup}?groupId=${groupId}`, {}, {
      headers: {
        Token: token,
      },
    });
  }

  getGroupDetails(groupId, token) {
    return http.get(`${APIS_CONSTANTS.getGroupDetails}/${groupId}`, {
      headers: {
        Token: token,
      },
      silentError: true,
    });
  }

  // Get user chat data
  getUserChatData(userId, token) {
    return http.get(`${APIS_CONSTANTS.getUserChatData}/${userId}`, {
      headers: {
        Token: token,
      },
    });
  }
}

const services = new Services();
export default services;
